import React from "react";
import CalendarStatusBadge from "./CalendarStatusBadge";
import { REQUEST_PENDING_STATUS, SCHEDULED_MULTI_SPONSOR_STATUS } from "../../utils/assessmentCalendarRules";

const SponsorRestrictedDetailsPanel = ({
  mode,
  providerName,
  onBack,
  onRequestToJoin,
}) => {
  const pending = mode === "pending";
  return (
    <div className="container px-4 py-8">
      <button type="button" className="text-sm font-semibold text-gray-500" onClick={onBack}>
        Assessment Calendar
      </button>
      <div className="mt-6 rounded-md border border-gray-200 bg-slate-50 p-6">
        <p className="text-sm text-gray-500">{providerName || "Assessment"}</p>
        <div className="mt-3">
          <CalendarStatusBadge status={pending ? REQUEST_PENDING_STATUS : SCHEDULED_MULTI_SPONSOR_STATUS} />
        </div>
        <dl className="mt-4 grid gap-2 text-sm text-gray-700">
          <div>
            <dt className="text-gray-500">Assessment Date</dt>
            <dd className="font-medium">Pending</dd>
          </div>
          <div>
            <dt className="text-gray-500">Release Date</dt>
            <dd className="font-medium">Pending</dd>
          </div>
        </dl>
        <p className="mt-4 text-sm text-gray-700">
          {pending
            ? "This join request is pending review. Assessment details, reports, and activity stay hidden until it is accepted."
            : "Request to join this multi-sponsor assessment to see details, reports, and activity."}
        </p>
        {!pending && onRequestToJoin ? (
          <button
            type="button"
            className="mt-4 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white"
            onClick={onRequestToJoin}
          >
            Request to Join
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default SponsorRestrictedDetailsPanel;
